import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

let cache = null;

export const useSettings = () => {
  const [s, setS] = useState(cache);
  useEffect(() => {
    if (cache) return;
    axios.get(`${API}/settings`).then((r) => {
      cache = r.data;
      setS(r.data);
    }).catch(() => {});
  }, []);
  return s;
};

export const clearSettingsCache = () => {
  cache = null;
};
